import { useCreativeCampaignData } from 'modules/campaigns/modules/creative-creator/hooks/useCreativeCampaignData';
import { isAppleTargeting } from 'modules/campaigns/modules/creative-creator/utils/isAppleTargeting';

export const useIsTargetingApple = () => {
    const { fetchedCampaign: campaign } = useCreativeCampaignData();
    return isAppleTargeting(campaign);
};
